import React, { useState, useEffect, useRef } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import DataTable from "react-data-table-component";
import Sidebar from "../common/sidebar";
import { dateformatwithuktime } from "../utilityfunctions";
import { useTranslation } from "react-i18next";
import ConfirmationPopup from "../common/confirmationPopup";

const UnsubscribedList = () => {
  const { t } = useTranslation();
  const filterRef = useRef(null);
  const [data, setData] = useState([]);
  const [templist, setTempList] = useState([]);
  const [searchTextVal, setSearchTextVal] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  // const [activeTab, setActiveTab] = useState("logged_in_not_order");

  const tabs = [
    { key: "logged_in_not_order", label: t("logged_in_ordered_email_txt") },
    { key: "abandoned_cart", label: t("abandoned_cart_email_txt") },
  ];
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [unsubscribe, setUnsubscribe] = useState({});

  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";

  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData")
    ).adminRole.permissions.includes("manage_emailcampaign.runemail")
  ) {
    window.location.href = "/unauthorized";
  }
  // Fetch data from API
  const requestIdRef = useRef(0);

  const fetchData = async () => {
    const id = ++requestIdRef.current;
    setIsLoading(true);
    try {
      let loginDetails = {};
      if (sessionStorage.getItem("authData")) {
        loginDetails = JSON.parse(sessionStorage.getItem("authData"));
      }
      let payload = {};
      let URL = BaseUrl + `admin/unsubscribedList`;
      const response = await http.post(URL, payload);
      let responseData = response.data.data;
      if (id === requestIdRef.current && response.data.success === true) {
        //const filteredData = responseData.filter((item) => !item.messageId && item.emailSentStatus === "sent");
        const filteredData = responseData;
        setTempList(filteredData);
        setData(filteredData);
      }
    } catch (err) {
      console.log(err);
    } finally {
      if (id === requestIdRef.current) {
        setIsLoading(false);
      }
    }
  };

  // Fetch whenever tab or email type changes
  useEffect(() => {
    // setSearchTextVal('');
    // const payload = {
    //   emailType: activeTab,
    // };
    fetchData();
  }, []);

  // Search filter
  useEffect(() => {
    filterData();
  }, [templist, searchTextVal]);

  const showDeletePopup = (value) => {
    setVisibleAlert(true);
    setUnsubscribe(value);
  };
  const alertPopupclose = () => {
    setVisibleAlert(false);
    setUnsubscribe({});
  };

  const deleteUnsubscribe = () => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }

    let URL = BaseUrl + `admin/deleteUnsubscribe/${unsubscribe._id}`;
    http
      .delete(URL)
      .then(async (response) => {
        if (response.data.success === true) {
          fetchData();
          setVisibleAlert(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const columns = [
    {
      name: t("account_code_txt"),
      selector: (row) => row?.accountCode,
    },
    {
      name: t("account_name_txt"),
      selector: (row) => row?.accountName,
    },
    {
      name: t("email_address_txt"),
      selector: (row) => row?.accountEmail,
    },
    {
      name: t("unsubscribtion_date_txt"),
      selector: (row) =>
        row?.createdAt ? dateformatwithuktime(row?.createdAt) : "-",
    },
    {
      name: t("actions_txt"),
      selector: (row) => (
        <div style={{ display: "flex" }}>
          <a
            className="button title-tooltip title-up"
            data-title={t("resubscribe_txt")}
            style={{ color: "white" }}
            onClick={() => showDeletePopup(row)}
          >
            <i className="fa fa-envelope-open" aria-hidden="true"></i>
          </a>
        </div>
      ),
      sortable: false,
    },
  ];

  const handleReset = () => {
    setSearchTextVal("");
  };
  const handleChange = async (value) => {
    setSearchTextVal(value);
  };
  useEffect(() => {
    function handleClickOutside(event) {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setIsMoreFilterVisible(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const filterData = async () => {
    let currentFilterData = templist;
    //Search Filter
    if (searchTextVal.length > 0) {
      const lowercasedValue = searchTextVal.toLowerCase().trim();
      const searchKeys = ["accountName", "accountCode", "emailType", "toEmail"];
      currentFilterData = currentFilterData.filter((item) =>
        searchKeys.some((key) =>
          item[key]?.toString().toLowerCase().includes(lowercasedValue)
        )
      );
    }
    setData(currentFilterData);
  };
  const customStyles = {
    rows: {
      style: {
        minHeight: "25px",
      },
    },
    headCells: {
      style: {
        padding: "8px", // override the cell padding for head cells
      },
    },
    cells: {
      style: {
        padding: "8px", // override the cell padding for data cells
      },
    },
  };
  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  return (
    <section className="dashboard-block">
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container">
            <div className="flex-title">
              <h1 className="checkout-title">
                {t("unsubscribed_customer_txt")}
              </h1>
            </div>
            <div className="right-table-outer-wrap">
              <div className="table-filter search-orders ">
                <div className="orders-drop-left">
                  <div className="table-search-reset">
                    <div className="table-search">
                      <input
                        type="text"
                        value={searchTextVal}
                        onChange={(e) => handleChange(e.target.value)}
                        className="form-control"
                        placeholder={t("unsubscribed_search_txt")}
                      />
                    </div>
                    <button
                      className="submitbtn button search-email-btn"
                      onClick={(e) => filterData(searchTextVal)}
                    >
                      <i className="fa fa-search"></i>
                    </button>

                    <button
                      className="resetbtn"
                      type="reset"
                      onClick={() => handleReset()}
                    >
                      {t("reset_txt")}
                    </button>
                  </div>
                </div>
              </div>
              {/* tabs */}
              {/* <div className="right-table-outer-wrap">
                <div className="flex-container">
                  <div className="header-tab-menu">
                    {tabs.map((tab) => (
                      <a
                        key={tab.key}
                        className={activeTab === tab.key ? "active" : ""}
                        onClick={() => setActiveTab(tab.key)}
                      >
                        {tab.label}
                      </a>
                    ))}
                  </div>
                </div> 
               </div> */}

              {!isLoading && data.length > 0 && (
                <div className="admin-order account-total-records">
                  <br />
                  {t("total_record_txt")} {data.length}
                </div>
              )}

              <div className="table_overflow email-logs-table">
                <DataTable
                  columns={columns}
                  noDataComponent={
                    <div className="no-records-found">
                      {searchTextVal !== ""
                        ? t("no_records_search_txt", {
                            recordType: "unsubscribed customers",
                          })
                        : t("no_record_txt")}
                    </div>
                  }
                  data={data}
                  customStyles={customStyles}
                  pagination
                  paginationPerPage={25}
                  progressPending={isLoading}
                  paginationRowsPerPageOptions={[100, 150, 200, 250]}
                  paginationComponentOptions={paginationComponentOptions}
                />
              </div>
            </div>
            {visibleAlert && (
              <ConfirmationPopup
                title={t("alert_txt")}
                confirmationMessage={t("resubscribe_confirmation_txt", {
                  accountCode: unsubscribe?.accountCode,
                })}
                handleYes={() => deleteUnsubscribe()}
                handleNo={() => alertPopupclose()}
              />
            )}
          </div>
        </section>

        <Footer />
      </div>
    </section>
  );
};
export default UnsubscribedList;
